/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pearl_Warm_Cow_CoilInputs */

const en_pearl_warm_cow_coil = /** @type {(inputs: Pearl_Warm_Cow_CoilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} users total`)
};

const de_pearl_warm_cow_coil = /** @type {(inputs: Pearl_Warm_Cow_CoilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Benutzer insgesamt`)
};

/**
* | output |
* | --- |
* | "{count} users total" |
*
* @param {Pearl_Warm_Cow_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_warm_cow_coil = /** @type {((inputs: Pearl_Warm_Cow_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Warm_Cow_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_warm_cow_coil(inputs)
	return de_pearl_warm_cow_coil(inputs)
});